import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/swap-funds/`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.error('No se encontró un token válido.');
    throw new Error('Usuario no autenticado');
  }
  return { Authorization: `Bearer ${token}` };
};

const handleError = (error) => {
  if (error.response?.data?.message === 'Invalid token') {
    console.error('Token inválido. Eliminando token de localStorage.');
    localStorage.removeItem('token');
    throw new Error('Token inválido. Por favor, inicie sesión nuevamente.');
  } else {
    console.error(error.response?.data || error.message);
    throw error;
  }
};

export const getUserBalances = async () => {
  try {
    const response = await axios.get(`${API_URL}user-balances`, {
      headers: getAuthHeaders(),
    });
    return response.data; // { freeBalance, balanceInGames, totalBalance }
  } catch (error) {
    handleError(error);
  }
};

export const getBalance = async () => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.get(`${API_URL}balance`, { headers });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
export const getGameFundBalance = getBalance; // getGameFundBalance se utiliza en send

export const getGames = async () => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.get(`${API_URL}games`, { headers });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getGameBalances = async () => {
    try {
      const headers = getAuthHeaders();
      const response = await axios.get(`${API_URL}game-balances`, { headers });
      return response.data;
    } catch (error) {
      handleError(error);
    }
  }

  export const getTransactions = async () => {
    try {
      const headers = getAuthHeaders();
      const response = await axios.get(`${API_URL}transactions`, { headers });
      return response.data;
    } catch (error) {
      handleError(error);
    }
  };

export const swapToGameBalance = async (payload) => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.post(`${API_URL}swap`, payload, { headers });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const withdrawFromGameBalance = async (payload) => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.post(`${API_URL}withdraw`, payload, { headers });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
